import type { BadmintonStandingItem } from '@/services/badmintonService';
import BadmintonPlayerAvatar from './BadmintonPlayerAvatar';

interface BadmintonStandingRowProps {
  item: BadmintonStandingItem;
}

const rankBadgeClass = (position: number): string => {
  switch (position) {
    case 1:
      return 'bg-[#FEF3C7] text-[#B45309]';
    case 2:
      return 'bg-[#E5E7EB] text-[#4B5563]';
    case 3:
      return 'bg-[#FFE4D5] text-[#C2410C]';
    default:
      return 'bg-[#F3F4F6] text-[#9CA3AF]';
  }
};

export default function BadmintonStandingRow({ item }: BadmintonStandingRowProps) {
  return (
    <div className="flex items-center gap-3 border-b border-gray-100 py-3 last:border-b-0">
      <span
        className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-xs font-bold ${rankBadgeClass(
          item.position
        )}`}
      >
        {item.position}
      </span>
      <BadmintonPlayerAvatar
        name={item.playerName}
        avatarUrl={item.avatarUrl}
        colorKey={String(item.participantId)}
        className="h-9 w-9 flex-shrink-0 text-sm"
      />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-bold text-gray-900">{item.playerName}</p>
        <p className="truncate text-[11px] text-gray-400">
          W: {item.wins} · L: {item.losses} · Winrate {item.winRate.toFixed(0)}%
        </p>
      </div>
      <div className="flex-shrink-0 text-right">
        <p className="text-lg font-extrabold leading-none text-[#FF5A1F]">{item.pointsScored}</p>
        <p className="text-[10px] uppercase tracking-wide text-gray-400">poin</p>
      </div>
    </div>
  );
}
